import React from "react";
import { Grid, Box, Typography } from "@material-ui/core";
import { useSelector } from "react-redux";
import moment from "moment";

import { ContractDetailTabText } from "./style";

const TenderDetailsTab = () => {
  const {
    adminContractDetails: { tenderDetails },
  } = useSelector((state) => state.admin);

  const details = [
    { title: "Tender Title	", value: tenderDetails.tenderName },
    { title: "Tender Status	", value: tenderDetails.status || "Not available" },
    { title: "Package Number	", value: tenderDetails.packageNumber || "Not available" },
    { title: "Procurement Method	", value: tenderDetails.procurementMethod || "Not available" },

    { title: "Number of Tenderers	", value: tenderDetails.tendererCount },
    { title: "Tendering Stage	", value: tenderDetails.tenderingStage },
    { title: "Review Method	", value: tenderDetails.reviewMethod },
    { title: "Bid Opening Date		", value: moment(tenderDetails.deadline).add(1, "days").format("DD, MMMM, yyyy") || "Not available" },
  ];

  return (
    <>
      <Box style={{ background: "#e4e9ec", padding: 20 }}>
        <Typography variant="h6" style={{ color: "#5F7483" }}>
          Award Details
        </Typography>
        <Typography style={{ color: "#5F7483" }}>Current Procurement Stage : {tenderDetails?.procurementStage || 'Implementation Stage'}</Typography>
      </Box>
      <Box>
        {details.map((detail, i) => (
          <Grid key={i} style={{ borderBottom: "1px solid #CBD4DA" }} container>
            <Grid item xs={3}>
              <ContractDetailTabText style={{ background: "#e4e9ec", boxShadow: "0px -1px 0px #C9D4DB" }}>
                {detail.title}
              </ContractDetailTabText>
            </Grid>
            <Grid item sm style={{ borderLeft: "1px solid #CBD4DA" }}>
              <ContractDetailTabText>{detail.value}</ContractDetailTabText>
            </Grid>
          </Grid>
        ))}
      </Box>
    </>
  );
};

export default TenderDetailsTab;
